import React from "react";
import { MapPin, Sparkles } from "lucide-react";
import { useLang } from "../lib/LangContext";

export const Coverage = () => {
  const { t } = useLang();
  return (
    <section
      id="coverage"
      className="px-6 md:px-12 lg:px-20 max-w-[1400px] mx-auto py-20 md:py-28"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-lokam-tangerine">
            {t.coverage.eyebrow}
          </p>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-lokam-forest">
            {t.coverage.title}
          </h2>
          <p className="mt-5 text-base md:text-lg text-lokam-ink-soft max-w-md">
            {t.coverage.subtitle}
          </p>
        </div>

        <div className="lg:col-span-7 space-y-8">
          {/* Available now */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="h-2 w-2 rounded-full bg-lokam-whatsapp animate-pulse" />
              <span className="text-sm font-semibold text-lokam-forest uppercase tracking-wider">
                {t.coverage.now}
              </span>
            </div>
            <div className="flex flex-wrap gap-2.5">
              {t.coverage.areas_now.map((area, i) => (
                <span
                  key={i}
                  data-testid={`coverage-now-${i}`}
                  className="inline-flex items-center gap-1.5 rounded-full bg-white border border-lokam-border px-3.5 py-2 text-sm font-medium text-lokam-ink hover:border-lokam-forest hover:text-lokam-forest transition-colors"
                >
                  <MapPin className="h-3.5 w-3.5 text-lokam-tangerine" />
                  {area}
                </span>
              ))}
            </div>
          </div>

          {/* Launching soon */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Sparkles className="h-4 w-4 text-lokam-tangerine" />
              <span className="text-sm font-semibold text-lokam-tangerine uppercase tracking-wider">
                {t.coverage.soon}
              </span>
            </div>
            <div className="flex flex-wrap gap-2.5">
              {t.coverage.areas_soon.map((area, i) => (
                <span
                  key={i}
                  data-testid={`coverage-soon-${i}`}
                  className="inline-flex items-center gap-1.5 rounded-full border border-dashed border-lokam-tangerine/40 bg-lokam-tangerine/5 px-3.5 py-2 text-sm font-medium text-lokam-tangerine"
                >
                  {area}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Coverage;
